import React from "react";
import PropTypes from "prop-types";
import ModalIntroMedia from "./ModalIntroMedia";
import i18next from "i18next";

const ModalOutroMedia = ({
    isOpen,
    mediaUrl,
    mediaType,
    title,
    buttonText,
    onContinue,
}) => {
    const defaultButtonText =
        buttonText ||
        (window.question && window.question.back_to_wheel) ||
        i18next.t("Back to the wheel") ||
        "Back to the wheel";

    return (
        <ModalIntroMedia
            isOpen={isOpen}
            mediaUrl={mediaUrl}
            mediaType={mediaType}
            title={title}
            buttonText={defaultButtonText}
            onContinue={onContinue}
        />
    );
};

ModalOutroMedia.propTypes = {
    isOpen: PropTypes.bool,
    mediaUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    mediaType: PropTypes.string,
    title: PropTypes.string,
    buttonText: PropTypes.string,
    onContinue: PropTypes.func.isRequired,
};

ModalOutroMedia.defaultProps = {
    isOpen: false,
    mediaUrl: "",
    mediaType: "video",
    title: "",
    buttonText: "",
};

export default ModalOutroMedia;
